/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */

import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import type {
	IncidentsPageInitialChecksResponse,
	IncidentsCustomFieldIdResponse,
	IncidentExperimentTraitsResourceData,
} from './IncidentsPageInitialChecksResponse.types.tsx';

export const incidentsInitialPageChecksResource: RouteResource<IncidentsPageInitialChecksResponse> =
	createResource<IncidentsPageInitialChecksResponse>({
		type: 'INCIDENTS_PAGE_INITIAL_CHECKS',
		getKey: ({ query }) => query.projectKey,
		getDataLoader: () =>
			import(
				/* webpackChunkName: "async-resource-incidents-initial-page-check", jiraSpaEntry: "async-resource-incidents-initial-page-check" */ './getData.tsx'
			),
	});

export const incidentsCustomFieldIdResource: RouteResource<IncidentsCustomFieldIdResponse> =
	createResource<IncidentsCustomFieldIdResponse>({
		type: 'INCIDENTS_PAGE_CUSTOM_FIELD_ID',
		getKey: ({ query }) => query.projectKey,
		getDataLoader: () =>
			import(
				/* webpackChunkName: "async-resource-incidents-custom-field-id-check", jiraSpaEntry: "async-resource-incidents-custom-field-id-check" */ './getCustomFieldIds.tsx'
			),
	});

export const incidentExperimentTraitResource: RouteResource<IncidentExperimentTraitsResourceData> =
	createResource<IncidentExperimentTraitsResourceData>({
		type: 'INCIDENT_EXPERIMENT_TRAITS',
		getKey: () => 'incident_experiment_traits',
		getDataLoader: () =>
			import(
				/* webpackChunkName: "async-resource-incident-experiment-traits", jiraSpaEntry: "async-resource-incident-experiment-traits" */ './GetIncidentExperimentTraitsGetData.tsx'
			),
		maxAge: Number.MAX_SAFE_INTEGER,
	});
